export default function styleVariables() {
  switch (process.env.NEXT_PUBLIC_CUSTOMER) {
    case "lecloset":
      return {
        fontFamily: "Nunito, Arial",
        inputBorderRadius: "8px",
        fontSizeBase: "16px",
        primary: "#870C27",
        middlePrimary: "#F7DDDF",
        tertiary: "#558066",
        dark: '#0C0C0C',
        danger: '#FF1F07',
        middleGray: "#A5A5A5",
        inputShadow: "0px 0px 6px rgba(229, 33, 89, 0.2)",
      };
    case "lgd":
      return {
        fontFamily: "Nunito, Arial",
        inputBorderRadius: "8px",
        fontSizeBase: "16px",
        primary: "#002E5D",
        middlePrimary: "#C2CDD8",
        tertiary: "#FFC73C",
        dark: '#0C0C0C',
        danger: '#FF1F07',
        middleGray: "#A5A5A5",
        inputShadow: "0px 0px 6px rgba(0, 46, 93, 0.2)",
      };
    default:
      return {};
  }
}
